import { useEffect } from "react";
import { Button, Icon, Flex, Text } from "@simplybusiness/mobius";
import { rightArrow } from "@simplybusiness/icons";

interface LetDownProps {
  fireEvent: (action: string) => void;
  onCTAClick: () => void;
}

export const LetDown = ({ fireEvent, onCTAClick }: LetDownProps) => {
  useEffect(() => {
    fireEvent("cd_rejection");
  }, [fireEvent]);

  return (
    <Flex
      className="mobius-interventions__coverage-diagnosis-letdown"
      data-testid="coverage-diagnosis-letdown"
      flexDirection="column"
      alignItems="baseline"
      justifyContent="center"
    >
      <Text elementType="h4">
        We apologise but this feature is not available at this time, please
        click the button below to complete a full quote.
      </Text>
      <Button
        className="mobius-interventions__coverage-diagnosis-cover-display-cta"
        size="sm"
        onPress={onCTAClick}
      >
        Close and continue&nbsp;&nbsp;
        <Icon size="sm" icon={rightArrow}></Icon>
      </Button>
    </Flex>
  );
};
